import React from "react";
import { Field, ErrorMessage } from "formik";
import { Select, MenuItem, FormControl, FormHelperText } from "@mui/material";

const CustomSelect = ({ name, options, props }) => {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      size="small"
      error={Boolean(
        props &&
          props.touched &&
          props.touched[name] &&
          props.errors &&
          props.errors[name]
      )}
    >
      <Field
        as={Select}
        name={name}
        id={name} // Use name as id or provide an appropriate id
        variant="outlined"
        error={Boolean(
          props &&
            props.touched &&
            props.touched[name] &&
            props.errors &&
            props.errors[name]
        )}
        size="small"
        required
        displayEmpty
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 280,
            },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Field>
      <FormHelperText sx={{ color: "red" }}>
        <ErrorMessage name={name} />
      </FormHelperText>
    </FormControl>
  );
};

export default CustomSelect;
